import { Component, OnInit } from '@angular/core';
import { SurveyListTableConfig } from "./survey-list.table-config";
import { BrokerAdminService, LocalStorageService, SurveyService } from '@app/services';
import { ApiResponse } from '@app/interfaces';
import { Router } from '@angular/router';
import { APP_ROUTES, USER_ROLES } from '@app/constants';
import { AppNotification } from '@app/helpers';
@Component({
  selector: 'app-survey-list',
  templateUrl: './survey-list.component.html',
  styleUrls: ['./survey-list.component.scss']
})
export class SurveyListComponent implements OnInit {
  panelVisible: boolean = false;
  config: any;
  isLoading: boolean = false;
  dataSource: any = []
  editSelected: any;

  constructor(
    private surveyService: SurveyService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.config = SurveyListTableConfig.configure();
    this.getList();
  }

  getList() {
    this.isLoading = true;
    this.surveyService.list().subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.dataSource = res.data
      }
    })
  }

  action(e: any) {
    this.editSelected = null;
    if (e.button?.eventName == "edit") {
      this.editSelected = e.data
      this.panelVisible = true;
    }
    if (e.button?.eventName == "add") {
      this.panelVisible = true;
    }
    if (e.button?.eventName == "details") {
      this.router.navigate([
        LocalStorageService.getUserRole() == USER_ROLES.ADMIN ?
          APP_ROUTES.SURVEY_DETAILS : APP_ROUTES.CONDUCT
      ], {
        queryParams: { surveyId: e.data._id }
      });
    }
    if (e.button?.eventName == "forms") {
      this.router.navigate([APP_ROUTES.FORM]);
    }
    if (e.button?.eventName == "addForm") {
      this.router.navigate([APP_ROUTES.FORM_BUILDER], {
        queryParams: { surveyId: e.data._id }
      });
    }
    if (e.button?.eventName == "copy") {
      this.cloneSurvey(e.data);
    }
    if(e.eventName == "row-edited") {
      if(!e.data?.length) return 
      this.onSaveHandler(e.data[0].data)
    }
  }

  onPopupclose() {
    this.panelVisible = false;
    this.editSelected = null;
    this.getList();
  }

  cloneSurvey(sourceSurvey: any) {
    this.surveyService.clone(sourceSurvey._id).subscribe({
      next: (res: any) => {
        AppNotification.success("Cloned!");
        this.getList();
      },
      error: (error: any) => {
        AppNotification.success("Something went wrong!");
      }
    })
  }

  onSaveHandler(survey: any) {
    console.log(survey)
    this.surveyService.update(survey._id, {
      name: survey.name
    }).subscribe({
      next: (res: any) => {
        AppNotification.success("success");
      },
      error: (error: any) => {
        AppNotification.error("something went wrong!");
      }
    })
  }
}
